import { ModalElement } from '@components/base/overlays/Modal';
import { useUniversalModalDispatch } from '@components/context/UniversalModalContext';
import React from 'react';
import { useUpdateUserMutation } from '@graphql/generated-graphql';
import { getClient } from '@graphql/graphql-client/graphClient';
import { useQueryClient } from 'react-query';
import { useUserSession } from '@hooks/user/useDefaultSession';
import { useDispatchError } from '@hooks/error/useDispatchError';
import { SimpleSpinner } from '@components/common/loading/SimpleSpinner';

export function TurnitinEulaModal({
    version,
    variant,
    onAccept,
}: {
    version: string;
    variant: 'upload' | 'view';
    onAccept?: () => void;
}) {
    const queryClient = useQueryClient();
    const { toggle } = useUniversalModalDispatch();
    const dispatchError = useDispatchError();
    const [user] = useUserSession();
    const [accepting, setAccepting] = React.useState<boolean>(false);
    const acceptTIIEulaMutation = useUpdateUserMutation(getClient('users'), {
        onMutate: () => {
            setAccepting(true);
        },
        onSettled: () => {
            setAccepting(false);
        },
        onSuccess: () => {
            toggle(false);
            queryClient.invalidateQueries('CurrentUser');
            if (onAccept) onAccept();
        },
        onError: () => {
            dispatchError('Could not accept Turnitin EULA');
        },
    });
    return (
        <ModalElement size="small">
            <ModalElement.Header type="warning">Accept Turnitin EULA</ModalElement.Header>
            <ModalElement.Body>
                {variant === 'upload' && (
                    <div>
                        Your files will be submitted to Turnitin for similarity and AI assessment.
                    </div>
                )}
                You must accept
                <a
                    href={`https://static.turnitin.com/eula/${version}/en-us/eula.html`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-teal-600 mx-1"
                >
                    Turnitin End-User License Agreement
                </a>
                to proceed
            </ModalElement.Body>
            {accepting ? (
                <div className={`mb-4`}>
                    <SimpleSpinner />
                </div>
            ) : (
                <ModalElement.ButtonContainer>
                    <ModalElement.ConfirmButton
                        type="success"
                        onConfirm={() => {
                            acceptTIIEulaMutation.mutate({
                                id: parseInt(user.id),
                                turnItInEulaVersion: version,
                            });
                        }}
                    >
                        Accept
                    </ModalElement.ConfirmButton>
                    <ModalElement.CancelButton onCancel={() => toggle(false)}>
                        Decline
                    </ModalElement.CancelButton>
                </ModalElement.ButtonContainer>
            )}
        </ModalElement>
    );
}
